<template>
  <div class="avis-preview" id="avis-preview">
    <h2 class="title">
      <fai class="icon" icon="thumbs-up"></fai>
      <span v-html="content.title"></span>
      <img
        class="trip"
        src="https://a.storyblok.com/f/56057/1501x1126/8f6420eff6/2017_coe_logos_all-black_translations_fr_fr-2.png"
      >
      <img
        class="tourisme"
        src="https://a.storyblok.com/f/56057/1654x1654/17fa1218ea/sticker-adherent-2022-detoure.png"
      >
    </h2>
    <ul v-if="avis">
      <li v-scroll-reveal="{ delay: 150 + i*100}" v-for="(a, i) in avis" :key="a.uid">
        <a :href="a.content.link.url" target="_blank">
          <h4>
            <fai class="icon" icon="quote-left"></fai>
            <span v-html="a.content.title"></span>
            <fai class="icon" icon="quote-right"></fai>
          </h4>
          <p class="avis-text" v-html="sliceContent(a.content.text)"></p>
          <star-rating
            class="avis-stars"
            :rating="getRating(a.content.score)"
            read-only
            :show-rating="false"
            :spacing="6"
            active-color="#5dc0d5"
            :increment="1"
          ></star-rating>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import api from "@/api";
export default {
  components: {
    StarRating
  },
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      avis: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { data } = await api.get(`cdn/stories`, {
        starts_with: `${this.$i18n.locale}/avis`
      });
      this.avis = data.stories;
    },
    getRating(score) {
      return Number(parseInt(score) || 0);
    },
    sliceContent(content) {
      return content.slice(0, 100) + "...";
    }
  }
};
</script>

<style lang="scss">
.avis-preview {
  position: relative;
  background: linear-gradient(135deg, $primary-D 0%, $primary 100%);
  margin-bottom: 2em;
  h2 {
    text-align: center;
    color: #fff;
    position: relative;
    .trip {
      width: 110px;
      height: auto;
      display: block;
      position: absolute;
      top: -40px;
      right: 25px;
      z-index: 1;
    }
    .tourisme {
      width: 80px;
      height: auto;
      display: block;
      position: absolute;
      top: -38px;
      right: 150px;
      z-index: 1;
    }
  }
  > ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
    width: $content-width;
    margin: auto;
    max-width: $max-width;
    padding-bottom: 60px;
    > li {
      box-shadow: 1px 0px 15px 3px rgba(0, 0, 0, 0.15);
      background: #edefed;
      display: flex;
      position: relative;
      min-width: 0;
      //height: 300px;
      border-radius: 30px;
      overflow: hidden;
      text-align: center;
      padding: 15px 10px;
      a {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }
      h4 {
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $black;
        font-weight: bold;
        .icon {
          font-size: 9px;
          margin: 0 5px;
          align-self: flex-start;
        }
        span {
          font-size: 20px;
        }
      }
      p {
        color: $black;
        text-align: justify;
        width: 100%;
        padding: 10px 5px;
        flex-grow: 1;
        font-size: 15px;
      }
      .avis-stars {
        svg {
          width: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 980px) {
  .avis-preview > ul {
    display: block;
    > li {
      width: 500px;
      margin: auto;
      margin-bottom: 30px;
      max-width: $max-width;
    }
  }
  .avis-preview h2 .tourisme {
    width:55px;
      top: -25px;
      right:90px;
  }
  .avis-preview h2 .trip {
    width:80px;
     top: -27px;
      right:5px;
  }
}
</style>
